<template>
    <BlockConfig title="Tabella misure"
        :valid="valid"
        @handleSave="handleSave"
        @restore="restore">
        <v-form v-model="valid">
            <div class="d-flex my-2">
                <v-text-field dense outlined
                    label="nome prova*"
                    :rules="[rules.mandatory]" 
                    v-model="config_data.title"
                ></v-text-field>
                <v-text-field dense outlined
                    v-model.number="config_data.min_readings"
                    class="ml-2"
                    label="nr. prove (min)"
                    :rules="[rules.mandatory]"
                ></v-text-field>
            </div>
            <div class="d-flex align-baseline my-2">
                <v-label class="font-weight-bold text-uppercase">EQUILIBRIO</v-label>
                <v-btn-toggle 
                    class="ml-6"
                    v-model="config_data.auto_balance" mandatory>
                    <v-btn color="primary" text>
                        NON AUTOMATICO
                    </v-btn>
                    <v-btn color="primary" text>
                        AUTOMATICO
                    </v-btn>
                </v-btn-toggle>                        
            </div>
            <div>
                <v-label>etichette<span class="caption"> - (ordine fisso)</span></v-label>
                <div class="d-flex mt-2 flex-wrap">
                    <v-text-field dense outlined label="posizione" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.divs"></v-text-field>
                    <v-text-field dense outlined label="massa" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.mass"></v-text-field>
                    <v-text-field dense outlined label="indicazione" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.reading"></v-text-field>
                    <v-text-field dense outlined label="carico addizionale" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.addLoad"></v-text-field>
                    <v-text-field dense outlined label="MPE" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.mpe"></v-text-field>
                    <v-text-field dense outlined label="esito" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.result"></v-text-field>
                </div>
            </div>
    </v-form>
</BlockConfig>
</template>

<script>
import {ConfigMixin} from '../../../../utils/configMixin_new'
import BlockConfig from '../../../../components/utils/BlockConfig'

export default {
    components: {BlockConfig},
    mixins:[ConfigMixin],
    // props: ["data"],
    data(){
        return{
            // valid: false,
            // rules: f_rules,
            o_data: {
                title: this.data.block.label,
                auto_balance: 0,
                min_readings: null,         
                headers: {
                    'divs': 'Divisioni',
                    'mass': 'Massa',
                    'reading': 'Indicazione',
                    'addLoad': 'Add. Load',
                    'mpe': 'MPE',
                    'result': 'Esito'
                }
            },
        }
    }
}
</script>